import React from "react";
import { MdInfo } from "react-icons/md";
import "./ErrorFooter.css";

const ErrorFooter = ({ message }) => {
  const errorMessage =
    message ||
    "Sorry, your action could not be completed. Please reload the page.";
  return (
    <div className="flex bg-black justify-between items-center p-4 shadow-lg z-100">
      <div>
        <MdInfo color={"red"} size={32} />
      </div>
      <div className="text-white text-base">
        <h3>{errorMessage}</h3>
      </div>
      <div></div>
    </div>
  );
};

export default ErrorFooter;
